import React from 'react';

import { FIELD_CATEGORY } from './constants';

export const SHOP_DATA_DEFAULT_MENU_ITEM_INDEX = 0;
export const SHOP_DATA_MENU_STEPS = {
  OCCUPANCIES: 0,
  DOCUMENTS: 1,
  SHOP_NOTES: 2,
  FEES: 0,
  ACCOMMODATIONS: 1,
};

export const SHOP_DATA_MODAL_GENERAL_SIDEBAR_MENU_ITEMS = [
  {
    step: SHOP_DATA_MENU_STEPS.OCCUPANCIES,
    label: 'Occupancies',
    key: FIELD_CATEGORY.OCCUPANCIES,
  },
  {
    step: SHOP_DATA_MENU_STEPS.DOCUMENTS,
    label: 'Brochures & Docs',
    key: FIELD_CATEGORY.DOCUMENTS,
  },
  {
    step: SHOP_DATA_MENU_STEPS.SHOP_NOTES,
    label: 'Shop Notes',
    key: FIELD_CATEGORY.SHOP_NOTES,
  },
];

export const SHOP_DATA_MODAL_LIVING_TYPE_SIDEBAR_MENU_ITEMS = [
  {
    step: SHOP_DATA_MENU_STEPS.FEES,
    label: 'Fees',
    key: FIELD_CATEGORY.FEES_INCENTIVES,
  },
  {
    step: SHOP_DATA_MENU_STEPS.ACCOMMODATIONS,
    label: 'Accommodation',
    key: FIELD_CATEGORY.ACCOMMODATIONS,
  },
];
